import { View, Text, ScrollView, Image, Platform, ActivityIndicator, Animated } from 'react-native'
import React, { useEffect, useState } from 'react'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import CommonHeader from '@app/sharedComponents/Header/Header'
import ScreenWrapper from '@app/hoc/ScreenWrapper'
import Stepper from '@app/sharedComponents/Stepper/Stepper'
import { useAppSelector, useAppDispatch } from '@app/store/hooks'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import Button from '@app/sharedComponents/Button/Button'
import { useTheme } from '@shopify/restyle'
import ShieldCheckIcon from '@app/assets/svg/ShieldCheckIcon'
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet'
import WhyMandate from './Components/WhyMandate'
import { postDSPMesage } from './util'
import { checkDigioMandateStatus, checkDigioMandateStatusTataApi, getUserProfileData, initiateDigioMandate, initiateTataMandate } from './digioMandateSignService'
import { getLenderRepayDate, getParameters, isIframe, removePathFromUrlWithouReload, removeUrlWithoutReload, trackEvent } from '@app/utils'
import ErrorMandateModal from './Components/ErrorMandateModal'
import SuccessMandateModal from './Components/SuccessMandateModal'
import { updateLinkedApplication } from '@app/store/slices/authSlice'
import { getNextRoute } from '@app/navigationApp/navigationUtil'
import { useLenderInfo } from '@app/hooks/useLenderInfo'
import { LENDER_ID } from '@app/types/regix'
import { useStepperData } from '@app/hooks/useStepperData'
import { hideErrorSheet, showErrorSheet } from '@app/store/slices/errorSlice'
import ContactUs from '../UserProfile/ContactUs'
import { useIsFocused } from '@react-navigation/native'
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder'
import LinearGradient from 'react-native-linear-gradient'
import handleApiErr from '@app/helper/handleApiErr'
import ROUTE from '@app/navigationApp/routes'
import { updatePartnerParams } from '@app/store/slices/platformSlice'
import MandateModal from './Components/MandateModal'
import MandateCancelled from './Components/MandateCancelled'
import TataMandateModal from './Components/TataMandateModal'
import { CreditApplicationSubType, CreditApplicationType } from '@app/configs/constants'
import { fetchBankAccountsFromApplication } from '../VerifyBankAccount/services/verifyBankService'

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'DIGIO_MANDATE_SIGN'>;

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const AnimatedShimmer = Animated.createAnimatedComponent(ShimmerPlaceholder);

const DigioMandateSign = ({ navigation, route }: ScreenProps) => {

    // 1. Navigation, props, theme
    const dispatch = useAppDispatch();
    const { colors } = useTheme<Theme>();
    const { params } = route;
    const isFocused = useIsFocused();
    const _isSuccessFromRedirect = params?.isSuccessFromRedirect;
    const showHome = useAppSelector(state => state.platformParams.showHome);

    // 2. Redux selectors
    const userDetails = useAppSelector(state => state.auth.userDetails);

    // 3. Custom hooks
    const { lenderInfo, isLoading: lenderInfoLoading } = useLenderInfo();
    const { stepperData, isLoading: stepperDataLoading } = useStepperData();

    // 4. State variables
    const [isDigioRedirect, setIsDigioRedirect] = useState<boolean>(false);
    const [error, setError] = useState<any>(null);
    const [userProfileData, setUserProfileData] = useState<any>(null);
    const [successLottie, setSuccessLottie] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [pendingAction, setPendingAction] = useState<null | (() => void)>(null);
    const [modalState, setModalState] = useState<'none' | 'error' | 'success' | 'contact_us' | 'mandate' | 'user_cancelled' | 'tata_mandate'>('none');
    const [isMandateModalVisible, setMandateModalVisible] = useState<boolean>(false);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [logo, setLogo] = useState<string>(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${userProfileData?.bankCode}.png`)
    const [mandateModalData , setMandateModalData] = useState({})
    const [tataMandateLink, setTataMandateLink] = useState<string>('');
    const [isUserUpdatingMandate, setIsUserUpdatingMandate] = useState(
        userDetails?.linkedApplications?.[0]?.applicationType === CreditApplicationType.CREDIT_LOAN_SERVICING_APPLICATION_AGAINST_SECURITIES 
        && userDetails?.linkedApplications?.[0]?.creditApplicationSubType === CreditApplicationSubType.MANDATE_UPDATE
    );
    const [bankDetails, setBankDetails] = useState(undefined);

    


    useEffect(() => {
        isUserUpdatingMandate === false && setLogo(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${userProfileData?.bankCode}.png`)
        trackEvent('MANDATE_SETUP_PAGE_VIEWED')
    }, [userProfileData])

    useEffect(() => {
        bankDetails && 
        isUserUpdatingMandate === true && 
        setLogo(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankDetails?.bankCode}.png`)
    }, [bankDetails])

    const fetchBankAccountFromApplication = async () => {
        try {
            const response = await fetchBankAccountsFromApplication({ applicationId: userDetails?.linkedApplications[0]?.applicationId });
            setBankDetails(response?.verifiedBankAccount)
        } catch (error) {
            console.error('bank account fetch error', error);
        } finally {
        }
    }

    useEffect(() => {
        //This is triggered when user is redirected from digio to 
        //volt app after successful mandate setup
        if (_isSuccessFromRedirect) {
            setModalState('success');
        }
        fetchBankAccountFromApplication();
    }, [isFocused]);

    // 5. Derived variables
    const lenderRepayDateString = getLenderRepayDate(lenderInfo?.data?.lenderBusinessDetails?.autopayDate);
    const isLenderDSP = userDetails?.linkedApplications[0]?.lenderAccountId?.toLowerCase() === LENDER_ID.DSP;
    const isLenderTata = userDetails?.linkedApplications[0]?.lenderAccountId?.toLowerCase() === LENDER_ID.TATA;



    const fetchSuccessLottie = async () => {
        try {
            const response = await fetch("https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json", {
                method: "GET",
            })
                .then((response) => response.json())
                .then((responseData) => {
                    setSuccessLottie(responseData);
                })
                .catch((error) => {
                    console.error(error);
                })
        } catch (error) {
            console.error(error);
        }
    }





    // functions for error modal
    const handleContactUs = () => {
        setModalState('contact_us');
        trackEvent('MANDATE_FAIL_CONTACT_US_CLICKED')
        // setPendingAction(() => navigation.navigate('CONTACT_US'));
    }

    const handleRetry = () => {
        trackEvent('MANDATE_FAIL_TRYAGAIN_CLICKED',{error: error?.message})
        // reset the navigation stack with home as the first screen
        if(Platform.OS === 'web') {
            setPendingAction(() => isLenderDSP ? handleContinueWebDSP : handleContinueWebTata);
        setModalState('none');

        } else {
            // TODO: chnage for tata
            if(isLenderDSP) {
                handleContinueAppDSP()
            }
        }

    }

    const handleChange = () => {
        setModalState('none');
        trackEvent('MANDATE_FAIL_TRY_DIFF_BANKACC_CLICKED',{error: error?.message})
        if(showHome){
        setPendingAction(() => navigation.reset({
            index: 0,
            routes: [{ name: 'HOME' }, { name: 'BANK_ACCOUNT_VERIFICATION' }]
        }));
        } else {
            setPendingAction(() => navigation.reset({
                index: 0,
                routes: [{ name: 'KYC_STEPPER' }, { name: 'BANK_ACCOUNT_VERIFICATION' }]
            }));
        }
    }


    const handleMobileDSPMandate = async (params: any) => {
        if (params.type !== undefined || params.error !== undefined || params.is_success !== undefined || params.digio_autopay_response === 'DSP') {

            const response = await checkDigioMandateStatus({ applicationId: userDetails?.linkedApplications[0]?.applicationId });


            if (response?.data?.stepResponseObject?.status === 'COMPLETED') {
                dispatch(updateLinkedApplication(response?.data?.updatedApplicationObj))
                setTimeout(() => {
                    setModalState('success');
                },500)
            }
            else if (params?.error === 'User%20Cancelled%20The%20Transaction') {
                setModalState('error')
                setError(response?.data?.stepResponseObject?.error)
            }
            else if (params?.type === 'cancel') {
                setModalState('user_cancelled')
            } else {
                setModalState('user_cancelled')
            }
        }
    }


    const handleRedirectFromDigioDSP = async () => {
        const url = Platform.OS === 'web' ? window.location.href : '';
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        const digio_autopay_response = params?.digio_autopay_response;
        if (digio_autopay_response) {

            setIsDigioRedirect(true);
            removeUrlWithoutReload("digio_autopay_response")
            removeUrlWithoutReload("status")
            removeUrlWithoutReload("digio_doc_id")
            removeUrlWithoutReload("message")
            removeUrlWithoutReload("npci_txn_id")
            removeUrlWithoutReload("error_code")
            const response = await checkDigioMandateStatus({ applicationId: userDetails?.linkedApplications[0]?.applicationId });
            if (response?.data?.stepResponseObject?.status !== 'COMPLETED' && response?.data?.stepResponseObject?.error !== null) {
                setModalState('error');
                setError(response?.data?.stepResponseObject?.error);
            }
            else if (response?.data?.stepResponseObject?.status === 'COMPLETED') {
                setModalState('success');
                dispatch(updateLinkedApplication(response?.data?.updatedApplicationObj))
                // TODO: write next step cred stepper
            }
            else {
                setModalState('error');
            }
        }
    }

    const handleRedirectFromDigioTata = async () => {
        const url = Platform.OS === 'web' ? window.location.href : '';
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        const tataMandateCallback = url.toString().includes('mandateCallback');
        if (tataMandateCallback) {
            try {
                const response = await checkDigioMandateStatusTataApi({ applicationId: userDetails?.linkedApplications[0]?.applicationId });
                if (response?.data?.stepResponseObject?.status === 'Finished') {
                    setModalState('success');
                    dispatch(updateLinkedApplication(response?.data?.updatedApplicationObj))
                }
                else if (response?.data?.stepResponseObject?.error !== null) {
                    setModalState('error');
                    setError(response?.data?.stepResponseObject?.error);
                }
            } catch (error: any) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    ctaLabel: 'Okay',
                    ctaAction: () => {
                        dispatch(hideErrorSheet());

                    }
                }));
            }
            finally {
                removeUrlWithoutReload("mandateCallback")
                removeUrlWithoutReload("appId")
                removeUrlWithoutReload("redirect")
                removeUrlWithoutReload("showVoltDefaultHeader")
                removePathFromUrlWithouReload("mandateCallback")
            }
        }
    }

    useEffect(() => {
        if (Platform.OS === 'web' && isLenderDSP) {
            postDSPMesage();
        }
    }, [isLenderDSP]);

    useEffect(() => {
        setIsLoading(true);
        if (Platform.OS === 'web' && isLenderDSP) {
            handleRedirectFromDigioDSP();
        } else if (Platform.OS === 'web' && isLenderTata) {
            handleRedirectFromDigioTata();
        }

        setIsLoading(false);
    }, [isLenderDSP, isLenderTata]);

    useEffect(() => {
        dispatch(updatePartnerParams({showCall:true}))
        setIsLoading(true);
        Promise.all([
            fetchUserProfileData(),
            fetchSuccessLottie()
        ]).finally(() => {
            setIsLoading(false);
        });
    }, []);


    const fetchUserProfileData = async () => {
        const response = await getUserProfileData({ payload: { accountId: userDetails?.linkedApplications[0]?.accountId } });
        setUserProfileData(response?.data?.bankDetails);
    }

    const superHandler = () =>{
        if(isLenderDSP) {
            handleContinueDSP()
        } else {
            handleContinueTata()
        }
    }

    const handleContinueDSP = () => {
        if(Platform.OS === 'web') {
            handleContinueWebDSP()
        } else {
            handleContinueAppDSP()
        }
    }

    const handleContinueTata = () => {
        if(Platform.OS === 'web') {
            handleContinueWebTata()
        } else {
            handleContinueAppTata()
        }
    }


    const handleContinueWebDSP = async () => {
        trackEvent('MANDATE_SETUP_CONTINUE_CLICKED')
        setIsProcessing(true);
        try {
            const response = await initiateDigioMandate({ applicationId: userDetails?.linkedApplications[0]?.applicationId , redirectionUrl : window?.location?.href });
            const data = response?.data?.stepResponseObject;

            if (data?.mandateMode === 'URL_REDIRECTION') {
                window.open(
                    data?.webUrl,
                    '_self',
                )
            }
        }
        catch (error: any) {
            if(handleApiErr(error)){
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message || error?.response?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode || error?.response?.data?.voltErrorCode || error?.response?.data?.statusCode,
                    ctaLabel: 'Retry',
                }));
            }
        }
        setIsProcessing(false);
    }

    const handleContinueAppDSP = async () => {
        setIsProcessing(true);
        try {
            const response = await initiateDigioMandate({ applicationId: userDetails?.linkedApplications[0]?.applicationId , redirectionUrl : 'https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false' });
            const data = response?.data?.stepResponseObject;

            setModalState('mandate')
            setMandateModalData(data)

            // if (data?.mandateMode === 'URL_REDIRECTION') {
            //     window.open(
            //         data?.webUrl,
            //         '_self',
            //     )
            // }
        }
        catch (error: any) {
            setModalState('none')
            if(handleApiErr(error)){
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message || error?.response?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode || error?.response?.data?.voltErrorCode || error?.response?.data?.statusCode,
                    ctaLabel: 'Retry',
                }));
            }
        }
        setIsProcessing(false);
    }


    const handleContinueWebTata = async () => {
        trackEvent('MANDATE_SETUP_CONTINUE_CLICKED')
        setIsProcessing(true);
        try {
            const response = await initiateTataMandate({ applicationId: userDetails?.linkedApplications[0]?.applicationId });
            navigation.navigate(ROUTE.DIGIO_AUTOPAY_INPROGRESS, { targetUrl: response?.data?.stepResponseObject });
        }
        catch (error: any) {
            if(handleApiErr(error)){
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    ctaLabel: 'Retry',
                    ctaAction: () => {
                        dispatch(hideErrorSheet());
                    }
                }));
            }
        } finally {
            setIsProcessing(false);
        }
    }

    const onTataMandateSuccess = () => {
        setModalState('success')
    }

    const onTataMandateError = () => {
        setModalState('none')
    }

    const handleContinueAppTata = async () => {
        setIsProcessing(true);
        try {
            const response = await initiateTataMandate({ applicationId: userDetails?.linkedApplications[0]?.applicationId });
            console.log('response', response?.data?.stepResponseObject);
            setTataMandateLink(response?.data?.stepResponseObject);
            setModalState('tata_mandate')
        } catch (error: any) {               
                if(handleApiErr(error)){
                    setModalState('error');
                    setError(error?.data?.message || error?.response?.data?.message);
                    dispatch(showErrorSheet({
                        isErrorSheetVisible: true,
                        errorMessage: error?.data?.message || error?.response?.data?.message,
                        closeOnBackdropPress: true,
                        errorType: error?.data?.voltErrorCode || error?.data?.statusCode || error?.response?.data?.voltErrorCode || error?.response?.data?.statusCode,
                        ctaLabel: 'Retry',
                    }));
                }
        }
        finally {
            setIsProcessing(false);
        }
    }

    const handleSuccess = () => {
        if(Platform.OS !== 'ios') {
        setModalState('none');
        }
        trackEvent('MANDATE_SETUP_SUCCESSBOTTOMSHEET_PAGEVIEW')
        
        if(isUserUpdatingMandate) {
            navigation.reset({
                index: 0,
                routes: [{ name: ROUTE.HOME }]
            })
        } else {
            navigation.reset({
                index: 0,
                routes: [{ name: showHome ? 'HOME' : 'KYC_STEPPER' }, { name: getNextRoute(userDetails?.linkedApplications[0].currentStepId, userDetails?.linkedApplications[0].applicationState, userDetails?.linkedApplications[0].stepStatusMap) }]
            })
        }
    }

    return (
        <ScreenWrapper>
            <ThemedView flex={1} bg='bg-surface-primary'>
                <CommonHeader
                    navigation={navigation}
                    pageName={route.name}
                    showNeedHelp={true}
                    hideBottomBorder={true}
                    label='Setup mandate'
                />
                <Stepper isLoading={stepperDataLoading} stepperData={stepperData} />
                <ThemedView flex={1}>
                    <ScrollView>
                        <ThemedView padding='lg' paddingTop='2xl' flex={1}>
                            <ThemedText mr='xl' variant='h5s' color='text-primary' mb='2xl'>
                                Setup mandate for hassle-free EMI payments
                            </ThemedText>

                            {/* Card Starts */}

                            {isLoading || lenderInfoLoading || stepperDataLoading ? (
                                <ThemedView minHeight={179} flex={1} justifyContent='center' alignItems='center'>
                                    <AnimatedShimmer
                                        style={{ opacity: 1 , width: '100%', height: 179 , borderRadius: 12}}
                                        shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
                                    />
                                </ThemedView>
                            ) : (
                                <ThemedView borderWidth={1} borderColor='border-secondary' borderRadius='md'>
                                    <ThemedView padding='lg' borderBottomWidth={1} borderBottomColor='border-secondary' gap='sm'>
                                        <ThemedView flexDirection='row' alignItems='center' justifyContent='space-between' flex={1}>
                                            <ThemedView>
                                                <ThemedText variant='b3r' color='text-secondary'>
                                                    {isUserUpdatingMandate ? bankDetails?.bankName : userProfileData?.bankName}
                                                </ThemedText>
                                                <ThemedText mt='xs' variant='b2s' color='text-primary'>
                                                    XXXX {isUserUpdatingMandate ? bankDetails?.accountNumber?.slice(-4) : userProfileData?.accountNumber?.slice(-4)}
                                                </ThemedText>
                                            </ThemedView>
                                            <Image source={{ uri: logo }}
                                                style={{ width: 40, height: 40 }}
                                                onError={() => {
                                                    setLogo(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png`)
                                                }}
                                            />
                                        </ThemedView>
                                        <ThemedTouchableOpacity onPress={() => {
                                            trackEvent('MANDATE_SETUP_CHANGEBNKACC_CLICKED')
                                            if(showHome){   
                                                navigation.reset({
                                                    index: 0,
                                                    routes: [{ name: 'HOME' }, { name: 'BANK_ACCOUNT_VERIFICATION' }]
                                                })
                                            } else {
                                                navigation.reset({
                                                    index: 0,
                                                    routes: [{ name: 'BANK_ACCOUNT_VERIFICATION' }]
                                                })
                                            }
                                        }}>
                                            <ThemedText variant='b3s' color='text-action-primary'>
                                                Change account
                                            </ThemedText>
                                        </ThemedTouchableOpacity>
                                    </ThemedView>
                                    <ThemedView justifyContent='space-between' padding='lg' paddingTop='2xl' flexDirection='row' alignItems='center' gap='sm'>
                                        <ThemedText variant='b3r' color='text-secondary'>
                                            Auto debit date
                                        </ThemedText>
                                        <ThemedText variant='b2s' color='text-primary'>
                                            {lenderRepayDateString}
                                        </ThemedText>
                                    </ThemedView>
                                </ThemedView>
                            )}
                            <ThemedTouchableOpacity onPress={() => {
                                setMandateModalVisible(true);
                                trackEvent('MANDATE_SETUP_WHY_CLICKED')
                            }}>
                                <ThemedText mt='md' variant='b3s' color='text-action-primary'>
                                    Learn why setup mandate?
                                </ThemedText>
                            </ThemedTouchableOpacity>
                        </ThemedView>
                    </ScrollView>
                    <ThemedView
                        style={{ width: '100%' }}
                        bg='bg-surface-primary'
                        padding='lg'
                        borderTopWidth={1}
                        borderTopColor='border-primary'
                    >
                        <ThemedView mb='lg' flexDirection='row' justifyContent='center' alignItems='center'>
                            <ShieldCheckIcon size={14} />
                            <ThemedText textAlign='center' ml='sm' color='text-emphasis-secondary' variant='b4r'>
                                Your data is secure with us
                            </ThemedText>
                        </ThemedView>
                        <Button
                            eventName='DIGIO_MANDATE_CONTINUE_CLICKED'
                            label="Continue"
                            type="SOLID"
                            size='MD'
                            buttonLoader={isProcessing}
                            handlePress={() => isLenderDSP ? handleContinueDSP() : handleContinueTata()}
                            bg={colors['bg-action-primary']}
                            textColor={colors['white']}
                        />
                    </ThemedView>
                </ThemedView>

            </ThemedView>
            <BottomSheetContainer
                showCloseIcon
                isVisible={isMandateModalVisible}
                close={() => setMandateModalVisible(false)}
                onClose={() => {
                    setMandateModalVisible(false);
                }}
                dragComponent={<View style={{ width: 40, height: 4, borderRadius: 10 }} />}
                containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 }}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
            >
                <WhyMandate onClose={() => {
                    setMandateModalVisible(false);
                    trackEvent('MANDATE_SETUP_WHY_OK_GOT_IT_CLICKED')
                }} />
            </BottomSheetContainer>
            <BottomSheetContainer
                showCloseIcon={modalState === 'error' || modalState === 'contact_us' || modalState === 'mandate' || modalState === 'user_cancelled' || modalState === 'tata_mandate'}
                isVisible={modalState !== 'none'}
                close={() => {
                    if (modalState === 'mandate') {
                        setModalState('user_cancelled');
                    } else {
                        setModalState('none');
                    }
                }}
                onClose={() => {
                    setModalState('none');
                    if (pendingAction) {
                        pendingAction();
                    }
                }}
                dragComponent={<View style={{ width: 40, height: 4, borderRadius: 10 }} />}
                containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 }}
                closeOnBackdropPress={modalState === 'error' || modalState === 'contact_us' || modalState === 'user_cancelled'}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
            >
                {modalState === 'error' && <ErrorMandateModal isProcessing={isProcessing} error={error} onContactUs={handleContactUs} onRetry={handleRetry} onChange={handleChange} />}
                {modalState === 'success' && <SuccessMandateModal lottie={successLottie} onPress={handleSuccess} />}
                {modalState === 'contact_us' && <ContactUs />}
                {modalState === 'mandate' && <MandateModal mandateModalData={mandateModalData} executeCheck={handleMobileDSPMandate} />}
                {modalState === 'tata_mandate' && <TataMandateModal onError={onTataMandateError} onSuccess={onTataMandateSuccess} mandateLink={tataMandateLink} />}
                {modalState === 'user_cancelled' && <MandateCancelled isLoading={isProcessing} onRetry={superHandler} onContactUsPressed={handleContactUs} />}
            </BottomSheetContainer>

        </ScreenWrapper>
    )
}

export default DigioMandateSign